import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=3a375818&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=3a375818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a375818",
  null
  
)

export default component.exports